import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJellyfinComponent } from './simple-icons-jellyfin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJellyfinComponent ],
    exports:      [ SimpleIconsJellyfinComponent ],
    bootstrap:    []
})
export class SimpleIconsJellyfinModule {}
